import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/index.css';

import { signin, authenticate, isAuth, loginWithGoogle } from '../actions';
import { useHistory } from 'react-router-dom';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(Yup);

export function FormLogin() {
  const [values, setValues] = useState({
    showPassword: false,
  });
  const history = useHistory();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Email Tidak Valid')
        .required('Email Tidak Boleh Kosong'),
      password: Yup.string().required('Password Tidak Boleh Kosong'),
    }),
    onSubmit: async (values) => {
      // toast('This is Toast')
      try {
        console.log('click from login');
        const user = {
          email: values.email,
          password: values.password,
        };
        console.log('data login', user);
        signin(user).then((data) => {
          console.log("ini data login", data);
          if (data.error) {
            toast.warning(data.error);
          } else {
            if (data.user.role === 1) {
            toast.success(data.message);              
            authenticate(data, () => {
              setTimeout(() => {
                history.push('/');
              }, 2000);
            });
            } else {
              toast.warning("Account is not activate, please confirm to admin")
            }
          }
        });
      } catch (e) {
        toast.warning('Something Wrong');
      }
    },
  });

  let errorUi;


  const handleClickShowPassword = () => {
    console.log('click');
    setValues({ showPassword: !values.showPassword });
  };

  return (
    <>
      <ToastContainer />
      <div className='mt-8'>
        <div className='mt-6'>
          <form onSubmit={formik.handleSubmit} className='space-y-6'>
            <div>
              <label
                htmlFor='email'
                className='block text-sm font-medium text-gray-700'
              >
                Email address
              </label>
              <div className='mt-1'>
                <input
                  id='email'
                  name='email'
                  type='email'
                  autoComplete='email'
                  required
                  className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
                  placeholder='example@example.com'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email ? (
                  <p className=' text-red-500 font-light text-xs text-right'>
                    {formik.errors.email}
                  </p>
                ) : null}
              </div>
            </div>

            <div className='space-y-1'>
              <label
                htmlFor='password'
                className='block text-sm font-medium text-gray-700'
              >
                Password
              </label>
              <div className='mt-1'>
                
                <div className='flex items-center rounded-md border border-gray-300'>
                  <div className='flex-auto w-full'>
                    <input
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.password}
                      placeholder='password kamu'
                      id='successPassword'
                      name='password'
                      type={values.showPassword ? 'text' : 'password'}
                      className='appearance-none border-none block w-full px-3 py-2 border  rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
                    />
                  </div>
                  <div
                    onClick={handleClickShowPassword}
                    className='flex-1 bg-gray-200 py-2 px-3 hover:text-primary cursor-pointer'
                  >
                    {values.showPassword ? (
                      <span className='la la-eye-slash '></span>
                    ) : (
                      <span className='la la-eye '></span>
                    )}
                  </div>
                </div>
                {formik.touched.password && formik.errors.password ? (
                  <p className=' text-red-500 font-light text-xs text-right'>
                    {formik.errors.password}
                  </p>
                ) : null}
              </div>
            </div>
            {errorUi}

            <div className='flex items-center justify-between'>
              <div className='text-sm'>
                <Link to='/auth/forgot-password' className='text-sm'>
                  Forgot your Password?
                </Link>
              </div>
              <button
                type='submit'
                className='btn btn_primary ml-auto uppercase'
                data-dashlane-rid='fd66152da8a85f08'
                data-dashlane-label='true'
                data-form-type='action,login'
              >
                Login
              </button>
            </div>
            <div className='flex items-center justify-between'>
              <div className='text-sm'>
                Don't Have an Account?
                <Link to='/auth/register' className='text-sm ml-1'>
                  Register
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
